import {observer} from 'mobx-react'
import CONTENT from '../stores/Content'
import UI from '../stores/UI'
import HELP from '../stores/Help'
import ProjectLink from '../components/ProjectLink'
import IntroPadding from '../components/IntroPadding'

const ColumnLayout = () => (
  <div className="default-bg-color index-cols innerx12">
    <span className="left-col">
      {CONTENT.selectedProjects.map(({fields}, i) => {
        // odd|even is actually reversed, because it starts at 0
        return !(i % 2) ? <ProjectLink {...fields} {...HELP.getMedia(fields.thumbnail)} key={fields.slug} /> : false
      })}
    </span>
    <span className="right-col">
      {CONTENT.selectedProjects.map(({fields}, i) => {
        // odd|even is actually reversed, because it starts at 0
        return i % 2 ? <ProjectLink {...fields} {...HELP.getMedia(fields.thumbnail)} key={fields.slug} /> : false
      })}
    </span>
  </div>
)

const MobileLayout = () => (
  <div className="default-bg-color innerx8">
    {CONTENT.selectedProjects.map(({fields}, i) => {
      return <ProjectLink {...fields} {...HELP.getMedia(fields.thumbnail)} key={fields.slug} />
    })}
  </div>
)

class Homepage extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    CONTENT.fetchHomepage()
    UI.homepageExists()
  }

  render() {

    return CONTENT.selectedProjects ? (
      <div className="fs max middle" style={{
        transition: `opacity 0.5s`,
        opacity: UI.isProjectOpen ? 0 : 1
      }}>
        <IntroPadding />
        {UI.isMobile ? <MobileLayout /> : <ColumnLayout />}
      </div>
    ) : (
      <div></div>
    )
  }
}

export default observer(Homepage)



// WEBPACK FOOTER //
// ./app/javascript/packs/pages/Homepage.js